export default "__VITE_ASSET__Dzd0rHJC__"